import { INITIAL_ESTATES_REQUEST, FETCH_ESTATES_SUCCESS, FINAL_ESTATES_REQUEST } from "../../types/maintainers/estates.type";

const initialState = {
	estates_parents: [],
	estates: [],
	customers: [],
	categories: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_business(state = initialState, action) {
	switch (action.type) {
		case INITIAL_ESTATES_REQUEST:
			return {
				...state,
				isFetching: true,
			};
		case FETCH_ESTATES_SUCCESS:
			return {
				...state,
				isFetching: false,
				estates_parents: action.payload.estates_parents,
				customers: action.payload.customers,
				estates: action.payload.estates,
				categories: action.payload.categories,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		case FINAL_ESTATES_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		default:
			return state;
	}
}

export default maintainers_business;
